import api from './api';

export const getLocations = (postcode: string) => {
  return api.get({
    path: `/locations/${postcode}`,
  });
};
